import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, extractApiError, tokenStore } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=unauth, obj=auth
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    api.get("/auth/me")
      .then((r) => { if (alive) setUser(r.data); })
      .catch(() => { if (alive) setUser(false); });
    return () => { alive = false; };
  }, []);

  const login = useCallback(async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.access_token) tokenStore.set(data.access_token);
      setUser(data);
      return true;
    } catch (e) {
      setError(extractApiError(e));
      return false;
    }
  }, []);

  const register = useCallback(async (email, password, name) => {
    setError("");
    try {
      const { data } = await api.post("/auth/register", { email, password, name });
      if (data.access_token) tokenStore.set(data.access_token);
      setUser(data);
      return true;
    } catch (e) {
      setError(extractApiError(e));
      return false;
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.error("Logout request failed:", err);
    }
    tokenStore.clear();
    setUser(false);
  }, []);

  const value = useMemo(
    () => ({ user, error, login, register, logout, setError, setUser }),
    [user, error, login, register, logout],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
